module.exports = __webpack_public_path__ + "a721372687dfb5123cbba24cb51fee28.svg";